import { useContext } from 'react';
import { ProjetoContext } from './projeto-context';

export function useProjeto() {
  const context = useContext(ProjetoContext);
  if (context === undefined) {
    throw new Error('useProjeto deve ser usado dentro de um ProjetoProvider');
  }
  return context;
}


